export default 'AIzaSyATZMtS7c4FOH2v0D5DkvFfoKW_n4Niq8I';
